import { firstValueFrom, Observable, switchMap, tap } from 'rxjs'
import { Injectable, Injector, Inject } from "@angular/core";
import { Brand } from '../../models/brand.interface';
import { BrandService } from '../../services/brand/brand.service';
import { AppConfig } from '../../models/app-config';

@Injectable()
export class BrandConfigService {
  public config: any = {
    appBaseHref: "/",
    slug: ""
  };

  constructor(
    @Inject('APP_CONFIG') private appConfig: AppConfig
  ) {
    this.setInitialData(appConfig.baseHref);
    this.setFavicons(appConfig.favIcon);
  }

  private setFavicons(faviconUrl: any): void {
    if (faviconUrl) {
      var linkElement = document.createElement("link");

      linkElement.setAttribute("rel", "icon");
      linkElement.setAttribute("type", "image/x-icon");
      linkElement.setAttribute("href", faviconUrl);

      document.head.appendChild(linkElement);
    }
  }

  public setInitialData(url:string) {    
    if (url == "") {
      this.config.appBaseHref = "/";
      this.config.slug = '';
    } else {
      this.config.appBaseHref = "/" + url;
      this.config.slug = url;
    }
  }

  set(k: string, v: any): void {
    this.config[k] = v;
  }

  get(k: string): any {
    return k ? this.config[k] : this.config;
  }
}
